import {graphql, PageProps} from 'gatsby';
import React, {memo} from 'react';

import PageElementGroup from '../components/page-element-group';

export const query = graphql`
	query ContactPage {
		allPagesJson(filter: {slug: {eq: "contact"}}) {
			nodes {
				...PageElementGroup
			}
		}
	}
`;


/**
 * @typedef {PageProps<
 *   import("../../tmp/graphql-types").ImprintPageQuery,
 *   {
 *     hashState: number,
 *     meta: import("../page-metadata").PageMetadata,
 *   }
 * >} ContactPageProps
 */
export default memo(
	/**
	 * @param {ContactPageProps} props props
	 * @returns {React.ReactElement} ...
	 */
	function ContactPage({data, pageContext: {hashState, meta}}) {
		return (
			<PageElementGroup
				name="main"
				nodes={data.allPagesJson.nodes}
				meta={meta}
				hashState={hashState}
			/>
		);
	}
);
